//
//
//
//
//
//


import QFabricModal from "../q-fabric-modal.vue";
import QAuModelPicker from "../Generics/ModelPicker/qAuModelPicker.vue";

export default {
    name: "QfModalModels",
    components: { QAuModelPicker, QFabricModal },
    props: {
        path: String,
        basePath: String,
        action: String,
        constraints: Object,
        title: String
    },
    data() {
        return {
            localShow: true,
            selected: false,
            update: false,
            pathModel: this.path
        };
    },
    computed: {
        actions() {
            return [{ label: "Set", name: "set", disable: this.update ? !this.selected : !this.path }];
        }
    },
    methods: {
        modelSelected(selectedObject) {
            this.selected = selectedObject.model;
            this.update = true;
            if (selectedObject.isEnter) {
                this.$emit("update", this.selected);
                this.localShow = false;
            }
        },
        modalAction(action) {
            if (action.simple === "hide") {
                this.localShow = false;
            } else if (action.simple === "action") {
                if (action.detailed === "set") {
                    if (this.update) {
                        this.$emit("update", this.selected);
                    }
                    this.localShow = false;
                }
            }
        },
        modalAfterHide() {
            this.$emit("input", false);
        }
    }
};
